/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Rows_Per_PageInputs */

const en_table_rows_per_page = /** @type {(inputs: Table_Rows_Per_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const pt_br2_table_rows_per_page = /** @type {(inputs: Table_Rows_Per_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas por página`)
};

/**
* | output |
* | --- |
* | "Rows per page" |
*
* @param {Table_Rows_Per_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_rows_per_page = /** @type {((inputs?: Table_Rows_Per_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Rows_Per_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_rows_per_page(inputs)
	return pt_br2_table_rows_per_page(inputs)
});